<template>
    <div v-if="visible" class="bg-white card mb-2" style="min-height: 90px">
        <div
            v-if="isStatusDone"
            class="card-body d-flex justify-content-evenly"
            style="gap: 1.25rem; justify-content: left"
        >
            <div class="d-flex gap-100 w-100 flex-column">
                <div
                    v-for="(result, key) in results"
                    class="d-inline-flex align-items-center justify-content-evenly bg-white w-100"
                    :class="{ 'border-top': key !== 0 }"
                >
                    <i
                        class="toast-icon"
                        :class="{
                            'far fa-exclamation-circle text-danger': !isValidationSuccessful(result),
                            'far fa-check-circle text-success': isValidationSuccessful(result),
                        }"
                    ></i>

                    <div class="w-75 text-normal">
                        <p class="my-3" v-html="getMainText(result)"></p>
                        <div v-if="result?.errors">
                            <ul class="pl-2">
                                <li class="font-size-100" v-for="error in cleanupErrors(result)">
                                    {{ error.rule }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <LoadingAnimation v-else-if="isStatusLoading" class="my-auto" :animation-style="'bars'"></LoadingAnimation>
    </div>
</template>

<script>
import { testIsTrueish, testIsUndefined } from '../../../../../lib/test-and-assert/test-base';
import { TOAST_HIDE, TOASTS } from './toast-consts';
import TransFilter from '../mixins/TransFilter.vue';
import { ApiJob } from '../../../../../model/converter/api-job';
import { satGlobals } from '../../../../sat/helper/sat-globals';
import { axiosWrapper } from '../../../../../lib/axios-wrapper/axios-wrapper';
import LoadingAnimation from '../LoadingAnimation.vue';
import DataStatus from '../mixins/DataStatus.vue';
import { translate } from '../../../../helper/translate';
import { eventBus } from '../../../../../lib/event-bus/event-bus';
import {RESULT_PDFA_JOB_GONE, RESULT_PDFA_VALIDATION_FAILED} from '../../../../../lib-sat/result/main-result';

export default {
    name: TOASTS.TOAST_RESULT_PDFA_VALIDATION,
    components: { LoadingAnimation },
    mixins: [TransFilter, DataStatus],
    props: {
        data: {
            type: ApiJob | null,
            default: null,
        },
    },
    async mounted() {
        await this.getPdfAValidationInfo();
        this.cleanupErrors();
    },
    beforeMount() {
        this.setStatusDone();
        this.visible = true;
    },
    methods: {
        async getPdfAValidationInfo() {
            this.setStatusLoading();
            const endpoint = satGlobals.getApiUrl(`/api/pdfa-result/${this.data.id}`);
            try {
                const response = await axiosWrapper.get(endpoint);

                this.results = JSON.parse(response.data);
            } catch (e) {
                eventBus.emit(TOAST_HIDE, TOASTS.TOAST_RESULT_PDFA_VALIDATION);
                eventBus.emit(RESULT_PDFA_JOB_GONE);
            }
            this.setStatusDone();
        },
        isValidationSuccessful(result) {
            return testIsTrueish(result?.profile?.compliant);
        },
        getMainText(result) {
            if (this.isValidationSuccessful(result)) {
                return this.translate(
                    'The document <strong>%filename%</strong> conforms to the %profile% standard.',
                    {
                        '%profile%': result?.profile?.name,
                        '%filename%': result?.filename,
                    }
                );
            } else {
              eventBus.emit(RESULT_PDFA_VALIDATION_FAILED);
                return translate(
                    'The validation for file <strong>%filename%</strong> against %profile% was not successful, your file broke the following rules:',
                    {
                        '%filename%': result?.filename,
                        '%profile%': result?.profile?.name,
                    }
                );
            }
        },
        cleanupErrors(result) {
            if (testIsUndefined(result)) {
                return null;
            }
            //Remove duplicate errors
            //https://dev.to/marinamosti/removing-duplicates-in-an-array-of-objects-in-js-with-sets-3fep
            return Array.from(new Set(result.errors.map((error) => error.rule))).map((rule) => {
                return result.errors.find((error) => error.rule === rule);
            });
        },
    },
    data() {
        return {
            visible: false,
            results: null,
            errors: null,
            profile: null,
        };
    },
};
</script>

<style scoped lang="scss">
@use '../../../../../../scss/abstracts/mixins' as *;
@use '../../../../../../scss/abstracts/functions' as *;
@use '../../../../../../scss/abstracts/variables' as *;
@use 'sat-styles/abstracts/variables' as *;

.toast-icon {
    border-radius: 50%;
    font-size: 3rem;

    @media (max-width: $screen-xs-max) {
        font-size: 2.5rem;
    }
}
</style>
